import { constants } from "../constants/redux-constants";

const initialState = {
  patientObj: {},
};

const PatientReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants?.PATIENTS?.PATIENT_OBJECT:
      return {
        ...state,
        patientObj: action?.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default PatientReducer;
